module.exports = "img/Punta-Gorda-Rotary-Club.0c8753.png";